/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNonTranslatable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M20 17h2V2H7v2h13z" />
      <path d="M13.4 11.9c.9-1.4 1.4-3.1 1.6-4.9h1V5h-6v2h2.9c-.1 1.1-.4 2.4-1 3.5L2.7 1.3 1.3 2.7l.7.7V22h3.5l3-4h8.1l4.7 4.7 1.4-1.4zM7.5 16l-3 4H4V5.4L14.6 16z" />
    </g>
  </Icon>
);
export { SvgNonTranslatable as NonTranslatable };
